import React from 'react';
import { Box, costFormater, Inscription, RawButton } from '@common-fe/common-fe';

interface Props {
  amount: number;
  top?: string;
  isOrganizationsList: boolean;
  organizationsCount: number;
  onViewOrganizations: () => void;
  onViewDetails: () => void;
}

const UnappliedFundsHomeBanner: React.FC<Props> = ({
  amount,
  top = '0px',
  isOrganizationsList,
  organizationsCount,
  onViewOrganizations,
  onViewDetails,
}) => (
  <Box
    data-testid="unapplied-funds-banner"
    width="100%"
    direction="row"
    justify="center"
    align="center"
    gap="spacing8"
    background="warningBorder"
    pad={{ vertical: 'spacing16', horizontal: 'spacing32' }}
    style={{ position: 'fixed', zIndex: 1003, top, left: 0 }}
  >
    <Inscription size="large" lineHeight="22px" data-testid="unapplied-funds-banner_text">
      {isOrganizationsList
        ? `${costFormater(amount, true)} in unapplied funds across ${organizationsCount} ${
            organizationsCount === 1 ? 'organization' : 'organizations'
          } needs to be applied to open invoices.`
        : `${costFormater(amount, true)} in unapplied funds needs to be applied to open invoices.`}
    </Inscription>
    <RawButton
      plain
      onClick={isOrganizationsList ? onViewOrganizations : onViewDetails}
      data-testid="unapplied-funds-banner_action"
    >
      <Inscription size="large" lineHeight="22px" color="textAccent" weight="normal">
        {isOrganizationsList ? 'View Organizations' : 'View Unapplied Funds'}
      </Inscription>
    </RawButton>
  </Box>
);

export default UnappliedFundsHomeBanner;
